import { StrictMode } from 'react'
import './i18n'
import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App.tsx'
import emailjs from '@emailjs/browser'

emailjs.init({ publicKey: 'uTDoFwu1Dq2FS62Zt' })

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
)